import Lottie from 'react-lottie'
import { useEffect, useState } from 'react'
import { getLottieAnimationJson } from './helpers'

interface LottieAnimationProps {
  height: number
  width: number
  url: string
}

const LottieAnimation: React.FC<LottieAnimationProps> = ({ height, width, url }) => {
  const [animationData, setAnimationData] = useState(null)
  const abortController = new AbortController()

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await getLottieAnimationJson(url, { signal: abortController.signal })
        setAnimationData(data)
      } catch (error) {
        console.error('Error fetching animation data:', error)
      }
    }

    fetchData()

    return () => {
      setAnimationData(null)
      abortController.abort() // Cancel the request if component unmounts
    }
  }, [])
  const options = {
    loop: true,
    autoplay: true,
    animationData,
  }

  return <Lottie options={options} width={width} height={height} />
}

export default LottieAnimation
